<template>
  <div class="contact-module" :class="{ brown: $route.path.includes('/healthcare') }">

    <section class="container-fluid col-xs-12 contact" id="contact">
      <div class="inside row">

        <h2 class="text-center" v-in-viewport="">{{labels.headline}}</h2>
        <p class="intro_text">{{labels.subheadline}}</p>
        <button @click="openJourney()" class="btn_orange" id="openJourney">{{labels.buttonLabel}}</button>
      </div>
    </section>

    <!-- YOUR JOURNEY -->
    <section id="your-journey" class="section-block  your-journey container-fluid col-xs-12" v-in-viewport="">
      <span class="triangle-top"></span>
      <div class="inner">

        <div class="inside row">
          <div class="col-md-6 col-lg-5 col-md-offset-1 col-lg-offset-2">
            <p class="text-small">* Required fields.</p>
          </div>

          <div class="row form-contact">
            <div class="col-md-6 col-lg-5 col-md-offset-1 col-lg-offset-2">
              <h4 class="title-form col-md-12">EMAIL US</h4>
              <form id="journeyForm" @submit.prevent="validateForm('journeyForm')" :data-vv-scope="'journeyForm'" action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads3285587000000368027 method='POST' accept-charset='UTF-8'  >
                <!-- Do not remove this code. -->
                <input type='text' style='display:none;' name='xnQsjsdp' value='f1c7c74f09065682e1d56ffe4c97645d08387b1b7086f4c6bb7118de4ad08959'/>
                <input type='hidden' name='zc_gad' id='zc_gad' value=''/>
                <input type='text' style='display:none;' name='xmIwtLD' value='4b98f2a03b7fb9570df3cb9573aed15d69311cd812fdbfc3e484707ced44bac8'/>
                <input type='text' style='display:none;'  name='actionType' value='TGVhZHM='/>
                <input type='text' style='display:none;' name='returnURL' value='http://newwebsite.mt.stage.mtllc.com/thank-you' />
                <input type='hidden' name='LEADCF1' id='LEADCF1' value='CX2 Landing Page'/><!-- Forn name -->
                <input type='hidden' name='LEADCF2' id='LEADCF2' value='CX2'/><!-- Whitepaper name -->
                <input type='hidden' name='LEADCF3' id='LEADCF3' value='Campaign name' v-model="journeyForm.campaign"/><!-- Campaign name -->



                <!-- Do not remove this code. -->

                <div class="form-row">
                  <div class="form-group col-md-6" :class="{error:errors.has('journeyForm.First Name')}">
                    <span class="required" v-if="journeyForm.firstname === ''">*</span>
                    <input type="text" class="form-control" id="firstname" maxlength='40' name='First Name' placeholder="First Name" v-validate="'required'" v-model="journeyForm.firstname">
                    <span class="message-error" v-show="errors.has('journeyForm.First Name')" >{{ errors.first('journeyForm.First Name') }}</span>
                  </div>
                  <div class="form-group col-md-6" :class="{error:errors.has('journeyForm.Last Name')}">
                    <span class="required" v-if="journeyForm.lastname === ''">*</span>
                    <input type="text" class="form-control"  id="lastname" maxlength='80' name='Last Name' placeholder="Last Name" v-validate="'required'" v-model="journeyForm.lastname">
                    <span class="message-error" v-show="errors.has('journeyForm.Last Name')" >{{ errors.first('journeyForm.Last Name') }}</span>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6" :class="{error:errors.has('journeyForm.Company')}">
                    <span class="required" v-if="journeyForm.company === ''">*</span>
                    <input type="text" class="form-control" id="company" maxlength='100' name='Company' placeholder="Company" v-validate="'required'" v-model="journeyForm.company">
                    <span class="message-error" v-show="errors.has('journeyForm.Company')" >{{ errors.first('journeyForm.Company') }}</span>
                  </div>
                  <div class="form-group col-md-6" :class="{error:errors.has('journeyForm.Email')}">
                    <span class="required" v-if="journeyForm.email === ''">*</span>
                    <input type="email" class="form-control" id="email" maxlength='100' name='Email' placeholder="Email" v-validate="'required|email'" v-model="journeyForm.email">
                    <span class="message-error" v-show="errors.has('journeyForm.Email')" >{{ errors.first('journeyForm.Email') }}</span>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12" :class="{error:errors.has('journeyForm.Description')}">
                    <!--<span class="required" v-if="journeyForm.description === ''">*</span>-->
                    <textarea id="message" rows="8" cols="80" class="track-it" placeholder="Your message" name='Description' maxlength='32000'></textarea>
                    <span class="message-error" v-show="errors.has('journeyForm.Description')" >{{ errors.first('journeyForm.Description') }}</span>
                  </div>
                </div>

                <div class="clearfix"></div>

                <input type='checkbox'  name='LEADCF104' checked='true' style='display:none;'>

                <div class="form-row">
                    <div class="form-group col-md-8 ">
                      <vue-recaptcha @verify="markRecaptchaAsVerifiedJourney" class="captcha" sitekey="6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"></vue-recaptcha>
                      <div class="captcha-error">
                        <p class="text-small">{{ journeyForm.pleaseTickRecaptchaMessage }}</p>
                      </div>
                    </div>
                    <div class="form-group col-md-4 submit-container" >
                      <button type="submit" tag="button" class="btn_orange gtm_buttonCX2_whitepaper_download">Submit</button>
                    </div>
                </div>

                <div v-if="journeyForm.formSubmitted" :class="[journeyForm.formSubmitted ? 'thank-message fadeIn' : '']">
                  <div class="row" v-in-viewport="">
                    <div class="col-lg-8 col-lg-offset-2">
                      <p class="text-center">Ok, you’ve taken the first step. We’ll get back to you within one business day.</p>
                    </div>
                  </div>
                </div>

              </form>
            </div>
            <div class="col-md-4 col-lg-3">
              <h4 class="col-md-12 text-center title-form strike"><span>CALL US</span></h4>
              <div class="col-md-12 white-box text-center">



                <div class="content" v-if="contactInfo == undefined ">
                  <strong>New Business</strong><br/>
                  <span>Mark Bachmann</span><br/>
                  <strong>(216) 514 4544</strong><br/>
                  <br/>
                  <strong>Web & Application Development</strong><br/>
                  <span>King Hill</span><br/>
                  <strong>(216) 285 2849</strong>
                </div>
                <div class="content" v-else>
                  <template  v-for="contact in contactInfo">
                    <strong>{{contact.position}}</strong><br/>
                    <span>{{contact.name}}</span><br/>
                    <strong>{{contact.phone}}</strong><br/>
                    <br/>
          				</template>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';
  import FileSaver from 'file-saver/FileSaver';

  export default {
    name:'contactForm',
    props: ['contactInfo','color','downloadDocument','labels'],
    data () {
      return {
        journeyForm: {
          recaptchaVerified: false,
          pleaseTickRecaptchaMessage: '',
          firstname:'',
          lastname:'',
          company: '',
          email: '',
          campaign: '',
          description: '',
          formSubmitted: false,
          open: false,
          label: 'Get Started',
          downloadDocument : true,
        },
      }
    },
    components:{
      VueRecaptcha
    },
    created:function(){
      console.log(this.labels);
      
       if(this.labels === undefined) {
         this.labels = {
           headline : 'Got a Challenge?',
           subheadline: 'We want to hear from you.',
           buttonLabel: 'GET STARTED'
         }
       }
       if(this.downloadDocument === undefined){
         this.journeyForm.downloadDocument = true;
       }
       else {
         this.journeyForm.downloadDocument = this.downloadDocument;
       }

       console.log(this.journeyForm.downloadDocument);
     },
    methods: {
      openJourney() {
        var elem = document.getElementById("your-journey");

        if(this.journeyForm.open==false){
          elem.classList.add("opened");
          //elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 330;
          document.getElementById('openJourney').innerHTML='CLOSE';

          setTimeout(function(){
            if (window.screen.width <= 768) {
              document.getElementById("your-journey").scrollIntoView({block: "start", behavior: "smooth"});
            }
            else {
              document.getElementById("your-journey").scrollIntoView({block: "end", behavior: "smooth"});
            }
            window.onresize = function(event) {
              elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
            };
          },300);

        }
        else {
          console.log('s');
          elem.classList.remove("opened");
          elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
          document.getElementById('openJourney').innerHTML='GET STARTED';

        }

        this.journeyForm.open =  !this.journeyForm.open;
      },
      markRecaptchaAsVerifiedJourney(response) {
        this.journeyForm.pleaseTickRecaptchaMessage = '';
        this.journeyForm.recaptchaVerified = true;
      },

      resetForm(scope) {
        this.$validator.pause();

        if(scope=='journeyForm' || scope=='healthcare'){
          this.journeyForm.recaptchaVerified = false;
          this.journeyForm.pleaseTickRecaptchaMessage = '';
          this.journeyForm.firstname = '';
          this.journeyForm.lastname = '';
          this.journeyForm.company = '';
          this.journeyForm.email = '';
          this.journeyForm.description = '';
        }

        this.$validator.errors.clear();
        this.$validator.reset();
        document.getElementById(scope).reset();
      },
      validateForm(scope) {
        console.log(scope);
        this.$validator.resume();
        const dict = {
          custom: {
            'Email': {
              required: 'This is a required field.',
              email: 'Please enter a validate email address'
            },
            'Last Name': {
              required: 'This is a required field.',
            },
            'First Name': {
              required: 'This is a required field.',
            },
            'Company': {
              required: 'This is a required field.',
            },
            'Description': {
              required: 'This is a required field.',
            }
          }
        };
        this.$validator.localize('en', dict);
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            //Check scope
            var formData = new FormData(document.getElementById(scope));
            var myForm;

          //  console.log("Aqui ///>'scope)



            if(scope=='journeyForm' || scope=='healthcare' ){
              myForm = this.journeyForm;
              if (!this.journeyForm.recaptchaVerified) {
                this.journeyForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
                return true; // prevent form from submitting
              }
            }


            this.$http.post ( 'https://crm.zoho.com/crm/WebToLeadForm', formData ).then(function (response) {
              // success actions
              if(response.statusText=="OK" || response.status == 200){
                myForm.formSubmitted = true;
                this.resetForm(scope);
                //console.log(this.scope);

                if(this.journeyForm.downloadDocument){
                  this.$http.get('/CX2-client.pdf',{responseType: 'arraybuffer'}).then((response) => {
                    var newBlob = new Blob([response.data], {type:"application/pdf"})
                    FileSaver.saveAs(newBlob, "CX2-client-experience-drives-customer-experience.pdf");
                  })
                }
              }
            });

            return false;

          }
        });
      },
    },
    computed: {
      defaultScope () {
        //console.log(this.scope)
        if(this.scope === undefined) {
          this.journeyForm.downloadDocument = true;
        }
        else {
          this.journeyForm.downloadDocument = false;
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// contact-form.vue?d23f7748